import { createSelector } from 'reselect'

export const getColonySettings = (state) => state.mars.colonySettings

export const getError = createSelector([getColonySettings], (info) => info.error)

export const getSaving = createSelector([getColonySettings], (info) => info.saving)

export const getNameInserted = createSelector([getColonySettings], (info) => info.nameInserted)

export const getName = createSelector([getColonySettings], (info) => info.name)

export const getShieldInserted = createSelector([getColonySettings], (info) => info.shieldInserted)

export const isTutorialPlayed = createSelector([getColonySettings], (info) => info.isTutorialPlayed)
